import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

import { inspectionItemColorIndex } from 'app/constants';
import { DataService, HelperService } from 'app/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-service-inspection',
  templateUrl: './service-inspection.component.html',
  styleUrls: ['./service-inspection.component.scss'],
})
export class ServiceInspectionComponent implements OnInit, OnDestroy {
  @Input() isFinalized: boolean = false;
  @Input() isArchived: boolean;
  @Input() isLockedRO: boolean = false;
  @Input() isFromOverview: boolean = false;
  @Input() isOwnerTechnician: boolean = false;
  @Input() assignedTo: string = '';
  @Input() isComplete: string = '';
  @Input() currentLang: string = 'en';
  @Input() companyLocalization: boolean = false;

  @Input('inspection')
  set inspection(inspection: any) {
    if (!inspection) {
      return;
    }
    this._inspection = inspection;

    if (inspection?.category && inspection.category.length) {
      this.counts = this.helperService.deepCopy(this.defaultCount);
      this.counts.categories = inspection?.category?.length ?? 0;
      inspection?.category?.forEach((category: any) => {
        if (category?.inspectionItems?.length) {
          this.counts.items += category?.inspectionItems?.length ?? 0;
          category?.inspectionItems?.forEach(
            ({ attachments, colorIndex }: any) => {
              if (colorIndex === -1) {
                this.counts.condition.notInspected += 1;
              } else {
                this.counts.condition[
                  inspectionItemColorIndex[colorIndex]
                ] += 1;
              }

              if (attachments && attachments.length) {
                attachments.forEach(({ type }) => {
                  if (type === 'image') {
                    this.counts.images += 1;
                  } else if (type === 'voice') {
                    this.counts.audios += 1;
                  } else if (type === 'video') {
                    this.counts.videos += 1;
                  }
                });
              }
            }
          );
        }
      });
    }

    this.categoryItemText = `
    ${this.counts.categories} ${this.counts.categories > 1 ? 'categories' : 'category'
      }
    ${this.counts.items} ${this.counts.items > 1 ? 'items' : 'item'}
    `;
  }

  @Output() appDeleteInspection = new EventEmitter();
  @Output() openInspectionDialog = new EventEmitter();

  defaultCount = {
    categories: 0,
    items: 0,
    condition: {
      good: 0,
      normal: 0,
      bad: 0,
      notInspected: 0,
    },
    images: 0,
    audios: 0,
    videos: 0,
  };
  counts = this.helperService.deepCopy(this.defaultCount);
  categoryItemText: string = '';

  _inspection: any = {};
  addMediaToInspectionEnabled: boolean = false;
  isDvi2Enabled: boolean = false;
  dataSubscription: Subscription;
  isDeletingInspection: boolean = false;

  constructor(private helperService: HelperService, private dataService: DataService) { }

  ngOnInit() {
    this.addMediaToInspectionEnabled = this.dataService.addMediaToInspections;
    this.isDvi2Enabled = this.dataService.isDvi2Enabled;
    this.dataSubscription = this.dataService.getData().subscribe((payload) => {
      if (payload.data && payload.data.key === 'company-appdata-updated') {
        this.addMediaToInspectionEnabled = this.dataService.addMediaToInspections;
        this.dataSubscription.unsubscribe();
      }
    });
  }

  handleOpenInspection() {
    if(this.isDeletingInspection) {
      return;
    }
    this.openInspectionDialog.emit({ inspectionId: this._inspection._id, associatedInspectionId: this._inspection.associatedInspectionId });
  }

  deleteInspection(event: Event) {
    this.isDeletingInspection = true;
    event.preventDefault();
    event.stopPropagation();

    this.appDeleteInspection.emit({
      inspectionId: this._inspection._id,
      title: this._inspection.title,
    });
  }

  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
}
